import { createContext, useState, useCallback } from "react";
import { ModalContextValue, ModalProviderProps } from "./types";


export const ModalContext = createContext<ModalContextValue>({
  activeModal: null,
  setActiveModal: () => {},
  disabled: { add: false, edit: true },
  setDisabled: () => {},
  refresh: false,
  setRefresh: () => {},
  refreshFileEditor: false,
  setRefreshFileEditor: () => {},
  RecordId: null,
  setRecordId: () => {},
  openModalFlag: undefined,
  setOpenModalFlag: () => {},
});

export function ModalProvider({ children }: ModalProviderProps) {
  const [activeModal, setActiveModal] = useState<
    | "add"
    | "edit"
    | "contact-person"
    | "employee"
    | "add-an-action-for-one-performer"
    | "add-an-action-from-a-template"
    | null
  >(null);
  const [disabled, setDisabled] = useState({
    add: false,
    edit: true,
  });
  const [refresh, setRefresh] = useState(false);
  const [refreshFileEditor, setRefreshFileEditor] = useState(false);
  const [RecordId, setRecordId] = useState<number | null>(null);
const [openModalFlag, _setOpenModalFlag] = useState<string | undefined>(undefined);

const setOpenModalFlag = useCallback((val: string | undefined) => {
  if (openModalFlag !== val) {
    // console.log('setOpenModalFlag ->', val);
    // console.trace(); // покаже стек, хто викликав
  }
  _setOpenModalFlag(val);
}, [openModalFlag]);


  return (
    <ModalContext.Provider
      value={{
        activeModal,
        setActiveModal,
        disabled,
        setDisabled,
        refresh,
        setRefresh,
        refreshFileEditor,
        setRefreshFileEditor,
        RecordId,
        setRecordId,
        openModalFlag,
        setOpenModalFlag
      }}
    >
      {children}
    </ModalContext.Provider>
  );
}
